/**
 * The four portal sections (PRD 3.1; KOVA-796). One registry drives the nav (desktop sidebar and
 * mobile side menu), the active-item state and the placeholder page titles, so a section is added or
 * renamed in one place. Routes point back here through `meta.portalSection` (src/router/index.ts).
 */
export type PortalSectionId = 'orders' | 'messages' | 'profile' | 'help'

export interface PortalSection {
	id: PortalSectionId
	/** The section's root route — where its nav item points. Sub-routes keep the same `meta.portalSection`. */
	path: string
	/** The nav label; also the title the section's page opens with (Figma 13716:85384). */
	label: string
}

export const PORTAL_SECTIONS: readonly PortalSection[] = [
	{ id: 'orders', path: '/orders', label: 'Orders management' },
	{ id: 'messages', path: '/messages', label: 'Messages' },
	{ id: 'profile', path: '/profile', label: 'Profile & Settings' },
	{ id: 'help', path: '/help', label: 'FAQ & Help' },
]

export function portalSection(id: PortalSectionId): PortalSection {
	const section = PORTAL_SECTIONS.find((candidate) => candidate.id === id)
	if (!section) throw new Error(`Unknown portal section: ${id}`)
	return section
}

/** A nav row: the section plus the state the shell renders on it. */
export interface PortalNavItem extends PortalSection {
	/** Show the unread dot (Messages only — PRD 3.3: a dot, never a count). */
	unread: boolean
}

declare module 'vue-router' {
	interface RouteMeta {
		/** The portal section a route belongs to; the nav highlights it. Set on every route under the shell. */
		portalSection?: PortalSectionId
	}
}
